import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord, FaHome } from 'react-icons/fa';
import Navbar from '../../components/Navbar/Navbar';
import { useT } from '../../i18n';
import './Error404.css';

const Error404 = () => {
  const t = useT();

  return (
    <div className="error404">
      <Navbar />

      <main className="error404-main">
        <div className="error404-glow" aria-hidden="true" />
        <div className="error404-blocks" aria-hidden="true" />

        <div className="error404-wrap">
          <p className="error404-kicker">{t('error404.kicker')}</p>
          <p className="error404-code" aria-hidden="true">
            404
          </p>
          <h1 className="error404-title">{t('error404.title')}</h1>
          <p className="error404-lead">{t('error404.lead')}</p>

          <div className="error404-actions">
            <Link to="/" className="error404-btn error404-btn--primary">
              <FaHome />
              {t('error404.backHome')}
            </Link>
            <a
              href="https://discord.gg/9W4Vusc4m2"
              target="_blank"
              rel="noopener noreferrer"
              className="error404-btn error404-btn--ghost"
            >
              <FaDiscord />
              {t('common.discord')}
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Error404;
